import * as React from 'react';
import classNames from 'classnames';
import { INewsItem } from 'src/Entities/News/NewsItem';
import { formatDate } from '../../../utils/dateUtils';
import NewsStatusTag from '../NewsStatusTag';
import { LoaderSlate } from '../../Loaders';
import ErrorState from '../../ErrorState';

export interface INewsModalContentProps {
  className?: string;
  status: 'idle' | 'loading' | 'loaded' | 'error';
  item?: Partial<INewsItem>
}

const NewsModalContent = ({
  className,
  status,
  item
}: INewsModalContentProps) => {
  const containerClassNames = classNames(
    'has-background-white p-14 flex-auto',
    className
  );
  const content: string | null = React.useMemo(() => {
    if (item && 'content' in item && item.content) {
      return item.content;
    }

    return null;
  }, [item]);

  if (status === 'error') {
    return (
      <div className={containerClassNames}>
        <ErrorState />
      </div>
    );
  }

  if (status === 'loading' && !item || !item) {
    return (
      <div className={containerClassNames}>
        <LoaderSlate />
      </div>
    );
  }

  return (
    <div className={containerClassNames}>
      <div className="text-sm has-text-gray-900 font-light uppercase flex items-center">
        {item.publishedAt && formatDate(item.publishedAt, 'do MMMM yyyy')}
        <NewsStatusTag
          item={{
            expiresAt: item.expiresAt || null,
            newsLabel: item.newsLabel
          }}
          className="ml-2"
        />
      </div>

      <h1 className="text-lg mt-2 mb-4 leading-6 font-semibold has-text-black">
        {item ? item.title : ''}
      </h1>
      {content && (
        <div
          className="NewsItemModalContent"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
};

export default NewsModalContent;



// WEBPACK FOOTER //
// ./src/components/News/NewsModal/Content.tsx